import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const EchartsWrapper = ({ options, style = { width: "100%", height: "400px" }, onEvents = {} }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  
  useEffect(() => {
     
    
     
    if (!chartRef.current) {
      console.error('EchartsWrapper: Contenedor no disponible');
      return;
    }
    
    try {
       
      if (chartInstance.current) {
         
        chartInstance.current.dispose();
      }
      
       
       
      chartInstance.current = echarts.init(chartRef.current);
      
       
      if (options) {
         
        chartInstance.current.setOption(options);
      }
      
       
      if (onEvents && typeof onEvents === 'object') {
        Object.keys(onEvents).forEach(eventName => {
          chartInstance.current.on(eventName, onEvents[eventName]);
        });
      }
      
       
      const handleResize = () => {
        if (chartInstance.current) {
          chartInstance.current.resize();
        }
      };
      
      window.addEventListener('resize', handleResize);
      
       
      setTimeout(() => {
        if (chartInstance.current) {
          chartInstance.current.resize();
        }
      }, 200);
      
       
      return () => {
        window.removeEventListener('resize', handleResize);
        if (chartInstance.current) {
           
          if (onEvents && typeof onEvents === 'object') {
            Object.keys(onEvents).forEach(eventName => {
              chartInstance.current.off(eventName, onEvents[eventName]);
            });
          }
          
          chartInstance.current.dispose();
          chartInstance.current = null;
        }
      };
    } catch (error) {
      console.error('EchartsWrapper: Error:', error);
    }
  }, [options, onEvents]);
  
  return (
    <div 
      ref={chartRef} 
      style={{
        ...style,
        minHeight: "300px",
        position: "relative",
        backgroundColor: "#fff"
      }}
    />
  );
};

export default EchartsWrapper;